// Money via Intl.NumberFormat (INR default). Dates via formatDate.
const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 });

export const formatMoney = (value, currency = 'INR') => {
  if (value == null || value === '') return '';
  if (currency === 'INR') return inr.format(Number(value));
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency }).format(Number(value));
};

export const formatDate = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateTime = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};
